import { useState, useEffect } from 'react'
export const MOBILE = 768

export default function useWindowSize () {
  const [windowSize, setWindowSize] = useState({
    width: 450,
    height: 400,
    isMobile: false
  })
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobile: window.innerWidth <= MOBILE
      })
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])
  return windowSize
}
